import React, { useEffect, useMemo, useState, useCallback } from 'react';
import './RancangPage.css';
import apiClient from '../services/api';
import { userSetItem } from '../utils/userStorage';
import { toast } from 'react-toastify';
import { ListState } from '../components/ListState';


// PDF Viewer
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";


import pdf1 from "../assets/adiksimba.pdf";

const themesList = [
  "Cerita Rakyat",
  "Sejarah Lokal",
  "Dokumentasi Budaya",
  "Kearifan Lokal",
  "Karya dan Pariwisata"
];

const pdfList = [

  {
    id: 1,
    name: "Pencarian Informasi ADIKSIMBA",
    file: pdf1,
    // description: "Panduan praktis untuk pengajar",
    color: "#4ECDC4"
  },

];


export default function Rencanakan({ onStorySaved }) {
  // ---- Form States
  const [language, setLanguage] = useState('indonesia');
  const [selectedTheme, setSelectedTheme] = useState('');
  const [personalization, setPersonalization] = useState('');
  const [selectedImageFile, setSelectedImageFile] = useState(null);


  // ---- UI/UX States
  const [saving, setSaving] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [listError, setListError] = useState('');

  // ---- List & Summary States
  const [stories, setStories] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [total, setTotal] = useState(0);
  const [searchQ, setSearchQ] = useState('');
  const [filterLang, setFilterLang] = useState('');
  const [filterTheme, setFilterTheme] = useState('');
  const [loadingList, setLoadingList] = useState(false);

  const [summary, setSummary] = useState({ total: 0, languages: [], themes: [], perTheme: [] });

  const totalPages = useMemo(() => Math.max(1, Math.ceil(total / limit)), [total, limit]);
  const [openDialog, setOpenDialog] = useState(null);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const defaultLayoutPluginInstance = defaultLayoutPlugin();


  // STATE UNTUK FORM
  const [mindMap, setMindMap] = useState({
    title: "",
    characters: [""],
    setting: { place: "", time: "", atmosphere: "" },
    plot: { conflict: "" },
    moralValue: ""
  });


  // Rancang Alur - Kerangka
  const [orientationFrame, setOrientationFrame] = useState("");
  const [conflictFrame, setConflictFrame] = useState("");
  const [resolutionFrame, setResolutionFrame] = useState("");
  const [codaFrame, setCodaFrame] = useState("");

  // Rancang Alur - Paragraf
  const [orientationPara, setOrientationPara] = useState("");
  const [conflictPara, setConflictPara] = useState("");
  const [resolutionPara, setResolutionPara] = useState("");
  const [codaPara, setCodaPara] = useState("");

  const handleMindMapChange = (e, key, subkey = null) => {
    if (subkey) {
      setMindMap(prev => ({
        ...prev,
        [key]: { ...prev[key], [subkey]: e.target.value }
      }));
    } else {
      setMindMap(prev => ({ ...prev, [key]: e.target.value }));
    }
  };

  const handleCharacterChange = (i, val) => {
    const updated = [...mindMap.characters];
    updated[i] = val;
    setMindMap(prev => ({ ...prev, characters: updated }));
  };

  const addCharacter = () => {
    setMindMap(prev => ({ ...prev, characters: [...prev.characters, ""] }));
  };

  const removeCharacter = (i) => {
    const updated = mindMap.characters.filter((_, idx) => idx !== i);
    setMindMap(prev => ({ ...prev, characters: updated }));
  };





  //karakter

  const handleOpen = (boxName) => {
    setOpenDialog(boxName);
    setSelectedPdf(pdfList[0]); // Set PDF pertama sebagai default
  };
  const handleClose = () => {
    setOpenDialog(null);
    setSelectedPdf(null);
  };
  const handlePdfSelect = (pdf) => {
    setSelectedPdf(pdf);
  };



  // function handleCharacterChange(index, value) {
  //   setMindMap(prev => {
  //     const updated = [...prev.characters];
  //     updated[index] = value;
  //     return { ...prev, characters: updated };
  //   });
  // }

  // function addCharacter() {
  //   setMindMap(prev => ({ ...prev, characters: [...prev.characters, ''] }));
  // }

  // function removeCharacter(index) {
  //   setMindMap(prev => {
  //     const updated = prev.characters.filter((_, i) => i !== index);
  //     return { ...prev, characters: updated };
  //   });
  // }


  // const handleMindMapChange = (e, section, subSection) => {
  //   const value = e.target.value;
  //   if (subSection) {
  //     setMindMap(prev => ({
  //       ...prev,
  //       [section]: {
  //         ...prev[section],
  //         [subSection]: value
  //       }
  //     }));
  //   } else {
  //     setMindMap(prev => ({
  //       ...prev,
  //       [section]: value
  //     }));
  //   }
  // };

  // ---- Validation sederhana
  function validateForm() {
    // if (!selectedTheme.trim()) return 'Pilih tema dulu.';
    if (!mindMap.title.trim()) return 'Judul cerita wajib diisi.';
    return '';
  }


  async function handleSave() {
    setErrorMsg('');

    const v = validateForm();
    if (v) {
      setErrorMsg(v);
      return;
    }

    setSaving(true);

    try {
      const formattedLanguage =
        language.toLowerCase() === "indonesia" ? "id" : language;

      const storedUser = localStorage.getItem("user");
      const userData = storedUser ? JSON.parse(storedUser) : {};

      // JSON payload
      const payload = {
        language: formattedLanguage,
        selectedTheme,
        personalization,
        author: userData.nama || "Anonim",

        mindMap: {
          title: mindMap.title,
          characters: mindMap.characters.filter(c => c.trim() !== ""),
          setting: {
            place: mindMap.setting.place,
            time: mindMap.setting.time,
            atmosphere: mindMap.setting.atmosphere,
          },
          plot: {
            introduction: mindMap.plot.introduction || "",
            conflict: mindMap.plot.conflict || "",
            resolution: mindMap.plot.resolution || "",
          },
          moralValue: mindMap.moralValue || "",
        },

        outline: {
          orientationFrame,
          conflictFrame,
          resolutionFrame,
          codaFrame,
          orientationPara,
          conflictPara,
          resolutionPara,
          codaPara,
        },
      };

      // FORM DATA (JSON + FILE)
      const formData = new FormData();
      formData.append("data", JSON.stringify(payload));

      if (selectedImageFile) {
        formData.append("image", selectedImageFile);
      }

      const { data } = await apiClient.post('/stories', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      toast.success(`Cerita berhasil disimpan! ID: ${data?.data?._id || "-"}`);
      userSetItem("rancang_story_saved", "1");
      onStorySaved?.();

      await Promise.all([
        fetchStories(page, filterLang, filterTheme, searchQ),
        fetchSummary()
      ]);

      handleResetForm();

    } catch (err) {
      console.error("Error saving story:", err);
      setErrorMsg(err.response?.data?.error || err.message || "Gagal menyimpan cerita");
    } finally {
      setSaving(false);
    }
  }



  function handleResetForm() {
    // Reset basic form
    setLanguage('indonesia');
    setSelectedTheme('');
    setPersonalization('');

    // Reset mindMap ke initial state
    setMindMap({
      title: "",
      characters: [""],
      setting: { place: "", time: "", atmosphere: "" },
      plot: { introduction: "", conflict: "", resolution: "" },
      moralValue: ""
    });

    // Reset semua outline states
    setOrientationFrame("");
    setConflictFrame("");
    setResolutionFrame("");
    setCodaFrame("");
    setOrientationPara("");
    setConflictPara("");
    setResolutionPara("");
    setCodaPara("");

    // Reset file
    setSelectedImageFile(null);

    // Reset messages
    setErrorMsg('');
  }

  // ---- Fetch List & Summary
  const fetchStories = useCallback(async (p = 1, lang = '', theme = '', q = '') => {
    setLoadingList(true);
    setListError('');
    try {
      const params = new URLSearchParams();
      params.set('page', String(p));
      params.set('limit', String(limit));
      if (lang) params.set('language', lang);
      if (theme) params.set('theme', theme);
      if (q) params.set('q', q);

      const { data } = await apiClient.get(`/stories?${params.toString()}`);
      setStories(data?.data || []);
      setTotal(data?.pagination?.total || 0);
    } catch (err) {
      setListError(err.response?.data?.error || err.message || 'Gagal ambil daftar data');
    } finally {
      setLoadingList(false);
    }
  }, [limit]); // cuma tergantung limit


  async function fetchSummary() {
    try {
      const { data } = await apiClient.get('/stories/summary');
      setSummary({
        total: data?.total || 0,
        languages: data?.languages || [],
        themes: data?.themes || [],
        perTheme: data?.perTheme || []
      });
    } catch (err) {
      console.warn('Gagal ambil summary:', err?.message);
    }
  }

  // ---- Init & whenever filters change
  useEffect(() => {
    fetchStories(page, filterLang, filterTheme, searchQ);
  }, [page, filterLang, filterTheme, searchQ, fetchStories]);


  useEffect(() => {
    fetchSummary();
  }, []);

  function onSearchClick() {
    setPage(1);
    fetchStories(1, filterLang, filterTheme, searchQ);
  }

  function openPdf(id) {
    window.open(`/api/stories/${id}/pdf`, '_blank', 'noopener,noreferrer');
  }
  function openPdfkerangka(id) {
    window.open(`/api/stories/${id}/pdfkerangka`, '_blank', 'noopener,noreferrer');
  }


  const getDialogContent = (boxName) => {
    switch (boxName) {
      case "ADIKSIMBA":
        return (
          <div className="pdf-viewer-layout">
            {/* PDF Sidebar */}
            <div className="pdf-sidebar">
              <div className="sidebar-header">
                <h3>📚 Materi Pembelajaran</h3>
                <span className="pdf-count">{pdfList.length} PDF Tersedia</span>
              </div>

              <div className="pdf-list">
                {pdfList.map(pdf => (
                  <div
                    key={pdf.id}
                    className={`pdf-item ${selectedPdf?.id === pdf.id ? "active" : ""}`}
                    onClick={() => handlePdfSelect(pdf)}
                    style={{ borderLeft: `4px solid ${pdf.color}` }}
                  >
                    <div className="pdf-item-icon">📄</div>
                    <div className="pdf-item-content">
                      <div className="pdf-item-title">{pdf.name}</div>
                      <div className="pdf-item-desc">{pdf.description}</div>
                    </div>
                    <div className="pdf-item-badge" style={{ background: pdf.color }}>
                      {pdf.id}
                    </div>
                  </div>
                ))}
              </div>

              {/* Quick Actions */}
              <div className="quick-actions-sidebar">
                <h4>🚀 Aksi Cepat</h4>
                <div className="action-buttons">
                  <button className="action-btn download">📥 Unduh</button>
                  <button className="action-btn print">🖨️ Print</button>
                  <button className="action-btn share">📤 Bagikan</button>
                </div>
              </div>
            </div>

            {/* PDF Viewer Area */}
            <div className="pdf-viewer-area">
              {selectedPdf && (
                <>
                  <div className="pdf-viewer-header">
                    <div className="pdf-info">
                      <h3>{selectedPdf.name}</h3>
                      <p>{selectedPdf.description}</p>
                    </div>
                    <div className="pdf-status">
                      <span className="status-badge">🟢 Tersedia</span>
                    </div>
                  </div>

                  <div className="pdf-container">
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                      <Viewer
                        fileUrl={selectedPdf.file}
                        plugins={[defaultLayoutPluginInstance]}
                        defaultScale={1.0}
                      />
                    </Worker>
                  </div>
                </>
              )}
            </div>
          </div>
        );


      default:
        return "";
    }
  };

  return (
    <div className="rencanakan-container">
      <h1>Rencanakan Cerita Inspiratif</h1>

      {(errorMsg) && (
        <div className={`alert alert-error`}>
          {errorMsg}
        </div>
      )}

      {/* --- FORM SECTION --- */}
      <section className="card form-section">
        <h2>Buat Cerita Baru</h2>

        {/* 1. CARI INFO */}
        <div className="sub-section">
          <h3>1. Cari Info</h3>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => handleOpen("ADIKSIMBA")}
          >
            Pencarian Informasi ADIKSIMBA
          </button>
        </div>

        {openDialog && (
          <div className="dialog-overlay" onClick={handleClose}>
            {/* <div className={`dialog-box ${openDialog === "Elemen Capaian" ? "pdf-dialog" : ""}`} onClick={(e) => e.stopPropagation()}> */}
            <div
              className={`dialog-box ${["ADIKSIMBA"].includes(openDialog)
                ? "pdf-dialog"
                : ""
                }`}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="dialog-header">
                <h2>{openDialog}</h2>
                <div className="dialog-icon">
                  {openDialog === "ADIKSIMBA" && "🎯"}
                </div>
              </div>

              <div className="dialog-content">
                {getDialogContent(openDialog)}
              </div>

              <div className="dialog-actions">
                <button className="close-btn" onClick={handleClose}>
                  Tutup ❌
                </button>
              </div>
            </div>
          </div>
        )}

        {/* 2. EKSPLOR ELEMEN */}
        <div className="sub-section">
          <h3>2. Eksplor Elemen Cerita</h3>

          <div className="form-group">
            <label>Judul Cerita</label>
            <input
              type="text"
              className="form-control"
              value={mindMap.title}
              onChange={(e) => handleMindMapChange(e, "title")}
            />
          </div>

          <div className="form-group">
            <label>Tokoh (Protagonis / Antagonis)</label>
            {mindMap.characters.map((c, idx) => (
              <div key={idx} className="input-row">
                <input
                  type="text"
                  className="form-control"
                  placeholder={`Tokoh ${idx + 1}`}
                  value={c}
                  onChange={(e) => handleCharacterChange(idx, e.target.value)}
                />
                {mindMap.characters.length > 1 && (
                  <button
                    className="btn btn-small btn-danger"
                    type="button"
                    onClick={() => removeCharacter(idx)}
                  >
                    -
                  </button>
                )}
              </div>
            ))}
            <button className="btn btn-small btn-secondary" type="button" onClick={addCharacter}>
              + Tambah Tokoh
            </button>
          </div>

          <div className="form-group">
            <label>Latar:</label>
            <div className="input-row">
              <input
                type="text"
                placeholder="Tempat"
                value={mindMap.setting.place}
                className="form-control"
                onChange={(e) => handleMindMapChange(e, "setting", "place")}
              />
              <input
                type="text"
                placeholder="Waktu"
                value={mindMap.setting.time}
                className="form-control"
                onChange={(e) => handleMindMapChange(e, "setting", "time")}
              />
              <input
                type="text"
                placeholder="Suasana"
                value={mindMap.setting.atmosphere}
                className="form-control"
                onChange={(e) => handleMindMapChange(e, "setting", "atmosphere")}
              />
            </div>
          </div>

          {/* <div className="form-group">
            <label>Konflik</label>
            <textarea
              className="form-control"
              rows={3}
              value={mindMap.plot.conflict}
              onChange={(e) => handleMindMapChange(e, "plot", "conflict")}
            ></textarea>
          </div> */}

          <div className="form-group">
            <label>Amanat / Nilai Moral</label>
            <input
              type="text"
              className="form-control"
              value={mindMap.moralValue}
              onChange={(e) => handleMindMapChange(e, "moralValue")}
            />
          </div>
        </div>

        {/* 3. RANCANG ALUR */}
        <div className="sub-section">
          <h3>3. Rancang Alur</h3>

          {/* A. Kerangka Cerita */}
          <h4>A. Kerangka Cerita (Kalimat Pendek)</h4>

          <div className="form-group">
            <label>Orientasi (Kerangka)</label>
            <input
              type="text"
              className="form-control"
              value={orientationFrame}
              onChange={(e) => setOrientationFrame(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Konflik (Kerangka)</label>
            <input
              type="text"
              className="form-control"
              value={conflictFrame}
              onChange={(e) => setConflictFrame(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Resolusi (Kerangka)</label>
            <input
              type="text"
              className="form-control"
              value={resolutionFrame}
              onChange={(e) => setResolutionFrame(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Koda (Kerangka)</label>
            <input
              type="text"
              className="form-control"
              value={codaFrame}
              onChange={(e) => setCodaFrame(e.target.value)}
            />
          </div>


          <hr />

          {/* B. Pengembangan Cerita */}
          <h4>B. Pengembangan Cerita (Paragraf)</h4>

          <div className="form-group">
            <label>Orientasi (Paragraf)</label>
            <textarea
              className="form-control"
              rows={4}
              value={orientationPara}
              onChange={(e) => setOrientationPara(e.target.value)}
            ></textarea>
          </div>

          <div className="form-group">
            <label>Konflik (Paragraf)</label>
            <textarea
              className="form-control"
              rows={4}
              value={conflictPara}
              onChange={(e) => setConflictPara(e.target.value)}
            ></textarea>
          </div>

          <div className="form-group">
            <label>Resolusi (Paragraf)</label>
            <textarea
              className="form-control"
              rows={4}
              value={resolutionPara}
              onChange={(e) => setResolutionPara(e.target.value)}
            ></textarea>
          </div>

          <div className="form-group">
            <label>Koda (Paragraf)</label>
            <textarea
              className="form-control"
              rows={4}
              value={codaPara}
              onChange={(e) => setCodaPara(e.target.value)}
            ></textarea>
          </div>
        </div>

        {/* 4. UPLOAD GAMBAR */}
        <div className="sub-section">
          <h3>4. Upload Gambar (Cover Buku)</h3>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setSelectedImageFile(e.target.files[0])}
          />


        </div>

        <div className="form-actions">
          <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? "Menyimpan..." : "Simpan Cerita"}
          </button>
          <button className="btn btn-secondary" type="button" onClick={handleResetForm}>
            Reset Form
          </button>
        </div>
      </section>


      {/* SUMMARY SECTION */}
      <section className="card summary-section">
        <h2>Ringkasan Data</h2>
        <div className="summary-grid">
          <div className="summary-item">
            <div className="summary-value">{summary.total}</div>
            <div className="summary-label">Total Entri</div>
          </div>
          <div className="summary-item">
            <div className="summary-value">{summary.languages?.length || 0}</div>
            <div className="summary-label">Variasi Bahasa</div>
          </div>
          <div className="summary-item">
            <div className="summary-value">{summary.themes?.filter(Boolean).length || 0}</div>
            <div className="summary-label">Variasi Tema</div>
          </div>
        </div>

        {/* {summary.perTheme?.length > 0 && (
          <div className="table-container">
            <h3>Jumlah Cerita per Tema</h3>
            <table className="data-table">
              <thead>
                <tr>
                  <th>Tema</th>
                  <th>Jumlah</th>
                </tr>
              </thead>
              <tbody>
                {summary.perTheme.map((t) => (
                  <tr key={t._id || '(kosong)'}>
                    <td>{t._id || '(kosong)'}</td>
                    <td>{t.count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )} */}
      </section>

      {/* LIST SECTION */}
      <section className="card list-section">
        <h2>Daftar Cerita</h2>

        <div className="filters">
          <input
            type="text"
            placeholder="Cari judul/tema/personalisasi…"
            value={searchQ}
            onChange={(e) => setSearchQ(e.target.value)}
            className="form-control"
          />
          <select
            value={filterLang}
            onChange={(e) => setFilterLang(e.target.value)}
            className="form-control"
          >
            <option value="">Semua Bahasa</option>
            <option value="indonesia">Indonesia</option>
            <option value="english">English</option>
          </select>
          <select
            value={filterTheme}
            onChange={(e) => setFilterTheme(e.target.value)}
            className="form-control"
          >
            <option value="">Semua Tema</option>
            {themesList.map((t) => (
              <option value={t} key={t}>{t}</option>
            ))}
          </select>
          <button className="btn btn-primary" onClick={onSearchClick}>Cari</button>
        </div>

        <div className="table-container">
          <ListState
            loading={loadingList}
            error={listError}
            empty={!loadingList && !listError && stories.length === 0}
            onRetry={() => fetchStories(page, filterLang, filterTheme, searchQ)}
            emptyProps={{
              icon: '📝',
              loadingMessage: 'Memuat daftar cerita...',
              title: 'Belum ada cerita tersimpan',
              message: 'Buat cerita baru di form di atas, lalu simpan untuk melihatnya di sini.',
            }}
          >
          <table className="data-table">
            <thead>
              <tr>
                <th>Judul</th>
                <th>Dibuat</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {stories.map((s) => (
                <tr key={s._id}>
                  <td title={s.mindMap?.title}>{s.mindMap?.title || '-'}</td>
                  <td>{s.createdAt ? new Date(s.createdAt).toLocaleString() : '-'}</td>
                  <td>
                    <button className="btn btn-small" onClick={() => openPdf(s._id)}>Unduh Naskah</button>
                  </td>
                  <td>
                    <button className="btn btn-small" onClick={() => openPdfkerangka(s._id)}>Unduh Kerangka</button>
                  </td>
                </tr>
              ))}
            </tbody>
            
          </table>
          </ListState>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button
            className="btn btn-secondary"
            disabled={page <= 1}
            onClick={() => setPage(p => p - 1)}
          >
            « Sebelumnya
          </button>
          <span>Halaman {page} dari {totalPages}</span>
          <button
            className="btn btn-secondary"
            disabled={page >= totalPages}
            onClick={() => setPage(p => p + 1)}
          >
            Selanjutnya »
          </button>
        </div>
      </section>
    </div>
  );
}